import React from 'react';

import css from './ReplacementsComponent.module.css';


const ReplacementsComponent = () => {
    return (
        <section className={css.wrap}>
            ReplacementsComponent
        </section>
    );
};

export {ReplacementsComponent};